import {httpClient} from "@/Repositories/Indicators/HttpClient";
import _ from "lodash";
import {GetIdFromObject} from "@/Repositories/helpers";

export default {

    /**
     * Creates a new Indicator
     *
     * @param Indicator
     * @returns {Promise<*>}
     */
    async storeIndicator(Indicator) {
        return httpClient.post(route('indicators.store'), Indicator);
    },


    /**
     * Fetch indicators based on given criteria

     * @returns {Promise<*>}
     */
    async searchIndicators() {
        return httpClient.get(route('indicators.getAll', {}));
    },

    /**
     * Deletes an indicator matching its identifier
     *
     * @param indicator
     * @returns {Promise<*>}
     */
    async deleteIndicator(indicator) {
        let indicatorId = GetIdFromObject(indicator);

        return httpClient.delete(route('indicators.delete', {indicator: indicatorId}));
    },

    /**
     * @param indicatorBookId
     *
     * @returns {Promise<*>}
     */
    async getIndicatorBook(indicatorBookId) {

        return httpClient.get(route('indicators.get', {indicatorBookId: indicatorBookId}));
    },

    /**
     * @returns {Promise<*>}
     */
    async getAllIndicatorBooks() {
        return httpClient.get(route('indicators.getAll', {}));
    },

    /**
     *
     * @param indicatorToCustomize
     *
     * @returns {Promise<*>}
     */
    async customize(indicatorToCustomize) {

        return httpClient.post(route('indicators.customize', {'indicator': indicatorToCustomize}));
    },


}
